import * as React from "react";
import * as Glob from "../Globale";
import { BasePureComponent } from "./BaseComponent";
import * as Dati from "../Dati";
import * as Data from "../Data";
import { Trad } from "../components/";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import MomentLocaleUtils, { formatDate, parseDate } from "react-day-picker/moment";
import "moment/locale/it";
import moment from "moment";

interface ICampoDataProps extends Dati.IBaseProps {
    Valore: Date | string | undefined;
    ValoreInArrivo: boolean; //Se viene fatto il render prima con valore vuoto e poi pieno, il calendario si apre senza selezionare il mese/anno della data scelta. Usare come: ValoreInArrivo={this.ID_Anag > 0}
    DataMinima?: Date;
    DataMassima?: Date;
    Disabilitato?: boolean;
    IsClearable?: boolean;
}

export class CampoData extends BasePureComponent<ICampoDataProps, {}> {
    private _Data: Date | string;
    private myRef: any;
    private inputRef: any;

    constructor(props: any) {
        super(props);
        this._Data = new Date(Date.now());
        this.myRef = React.createRef();
        this.inputRef = React.createRef();
    }

    public render() {
        if (this.props.Valore == undefined) {
            this._Data = "";
        } else if (typeof this.props.Valore == "string") {
            this._Data = moment(this.props.Valore).toDate();
        } else {
            this._Data = this.props.Valore;
        }

        if (this.props.Valore == undefined && this.props.ValoreInArrivo) {
            return false;
        } else {
            this._Data = this.props.Valore || "";

            let DateValori = new Data.CDateTZLess(this.props.Valore);

            if (this.props.DataMinima != undefined && this.props.Valore != undefined && DateValori.IsLowerThan(this.props.DataMinima)) {
                Glob.InfoModaleWarning("WARNING", Trad.TradParam("LaDataNonPuoEssereAntecedenteIl{1-D}", [this.props.DataMinima]));
                this._Data = this.props.DataMinima;
                this.props.OnChange(this.props.Name, this._Data);
            }

            if (this.props.DataMassima != undefined && this.props.Valore != undefined && DateValori.IsGreaterThan(this.props.DataMassima)) {
                Glob.InfoModaleWarning("WARNING", Trad.TradParam("La data non può essere posteriore il: {1-D}", [this.props.DataMassima]));
                this._Data = this.props.DataMassima;
                this.props.OnChange(this.props.Name, this._Data);
            }
            if (this.props.Disabilitato != undefined && this.props.Disabilitato) {
                return <div className={"DayPickerInput kt-input-icon kt-input-icon--right"}>{this._Data == "" ? "" : Data.DataValoreTrad(moment(this._Data).toDate())}</div>;
            } else {
                return (
                    <DayPickerInput
                        ref={this.myRef}
                        name={this.props.Name}
                        formatDate={formatDate}
                        parseDate={parseDate}
                        format={Trad.Trad("DD/MM/YYYY")}
                        classNames={{
                            container: "DayPickerInput kt-input-icon kt-input-icon--right",
                            overlayWrapper: "DayPickerInput-OverlayWrapper",
                            overlay: "DayPickerInput-Overlay"
                        }}
                        component={React.forwardRef((props: any, ref) => (
                            <>
                                <input {...props} ref={ref} />
                                {this.props.IsClearable && (
                                    <span className="kt-input-icon__icon kt-input-icon__icon--right">
                                        <span onClick={() => this.props.OnChange(this.props.Name, "")}>
                                            <i className="la la-close" />
                                        </span>
                                    </span>
                                )}
                            </>
                        ))}
                        showClear
                        datepicker-append-to-body
                        onDayChange={async (day: Date) => {
                            if (day != undefined) {
                                await this.props.OnChange(this.props.Name, new Date(Date.UTC(day.getFullYear(), day.getMonth(), day.getDate(), 0, 0, 0, 0)));
                                this.inputRef.current.focus();
                            }
                        }}
                        placeholder={`${Trad.Trad("PlaceholderData")}`}
                        value={this._Data == "" ? "" : new Date(this._Data.toString())}
                        dayPickerProps={{
                            locale: Glob.GetLocale() == undefined ? "it" : Glob.GetLocale().Lingua,
                            localeUtils: MomentLocaleUtils
                        }}
                        inputProps={{
                            onKeyUp: (e: React.KeyboardEvent<any>) => {
                                if (e.key === "Enter") {
                                    this.myRef.current.hideDayPicker();
                                }
                            },
                            onBlur: (e: React.FormEvent<any>) => {
                                if (this.props.OnBlur != undefined) {
                                    this.props.OnBlur(e);
                                }
                            },
                            ref: this.inputRef
                        }}
                    />
                );
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/CampoData.tsx